/**
 * The roles a new user can pick from on the first step of onboarding.
 */
export const onboardingRoles = ['devOps', 'itOps', 'msp', 'sre', 'other'] as const;

export type OnboardingRole = (typeof onboardingRoles)[number];

export const roleDisplayNames: Record<OnboardingRole, string> = {
    devOps: 'DevOps',
    itOps: 'ITOps',
    msp: 'MSP',
    sre: 'SRE',
    other: 'Other'
};
